<template>
    <div class="options">
        <p class="options__text">Options for Crosspromotion:</p>
        <div v-if="emailNewsletterOption" class="options__item">
            <div class="options__content">
                <p class="options__text options__text-item">Email</p>
                <Social
                    icon="emailshop"
                    :subscribers="options['email-newsletter'].info"
                    size="sm"
                    type="default"
                />
            </div>
        </div>
        <div v-if="socialOptions" class="options__item">
            <div class="options__content">
                <p class="options__text options__text-item">Social Media</p>
                <SocialGroup
                    :social-group="options['social-media-post'].info"
                    size="sm"
                    type="default"
                />
            </div>
        </div>
        <div v-if="blogPostOption" class="options__item mb-3">
            <div class="options__content">
                <p class="options__text options__text-item">Blog Post</p>
                <a :href="options['blog-post'].info" target="_blank">{{options['blog-post'].info}}</a>
            </div>
        </div>
        <div v-if="websiteBannerOption" class="options__item mb-3">
            <div class="options__content">
                <p class="options__text options__text-item">Website banner</p>
                <a :href="options['website-banner'].info" target="_blank">{{options['website-banner'].info}}</a>
            </div>
        </div>
        <div v-if="otherOption" class="options__item mb-3">
            <div class="options__content">
                <p class="options__text options__text-item">Other</p>
                <p>{{options.other.info}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Social from './Social'
import SocialGroup from './SocialGroup'
import Icon from '@/components/Theme/Icon'
export default {
    name: 'Options',
    components: {
        Icon,
        Social,
        SocialGroup
    },
    props: {
        options: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        emailNewsletterOption() {
            return this.options && this.options['email-newsletter'].active
        },
        socialOptions() {
            return this.options && this.options['social-media-post'].active
        },
        blogPostOption() {
            return this.options && this.options['blog-post'].active
        },
        otherOption() {
            return this.options && this.options.other.active
        },
        websiteBannerOption() {
            return this.options && this.options['website-banner'].active
        }
    }
}
</script>

<style lang="scss" scoped>
$color: #333333;
$fontsize: 16px;
$lineheight: 24px;
.options {
    padding-left: 12px;
    overflow-wrap: anywhere;
    &__item {
        margin-top: 16px;
        display: flex;
        align-items: baseline;
    }
    &__text {
        color: $color;
        font-size: $fontsize;
        line-height: $lineheight;
        font-weight: bold;
        margin-bottom: 6px;
        position: relative;
        &.options__text-item {
            &::before {
                content: url(/icons/option.svg);
                position: absolute;
                top: 50%;
                right: 100%;
                transform: translate(-88%, -40%);
            }
        }
    }
    &__icon {
        margin-right: 12px;
    }

    &__item {
        margin-left: 30px;
    }
}
</style>>
